import React, { FC, ReactNode } from 'react'

export const RoomsHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/fro/sales-journey/hos/rle-wizard/icons/0.02/Room_HighLighter_Icon.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/bd9ead5f8487af93bc628769b362a944_Rooms_HighLighter_Icon@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/fro/sales-journey/hos/rle-wizard/icons/0.02/Rooms_HighLighter_Icon@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/fro/sales-journey/hos/rle-wizard/icons/0.02/Room_HighLighter_Icon.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
